<ng-container *ngIf="interests | async as profile; else loading">
  <ng-container *ngFor="let interest of profile">
    <div class="mt-3 animated fadeIn" role="layout">
      <ng-container *ngIf="interest.teaching.length > 0">
        <h4>Teaching Interests</h4>
        <p [innerHTML]="decode(interest.teaching) | safeHtml"></p>
      </ng-container>

      <ng-container *ngIf="interest.research.length > 0">
        <h4>Research Interests</h4>
        <p [innerHTML]="decode(interest.research) | safeHtml"></p>
      </ng-container>

      <ng-container *ngIf="interest.service.length > 0">
        <h4>Service Interests</h4>
        <p [innerHTML]="decode(interest.service )| safeHtml"></p>
      </ng-container>

      <ng-container *ngIf="interest.clinical.length > 0">
        <h4>Clinical Interests</h4>
        <p [innerHTML]="decode(interest.clinical) | safeHtml"></p>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="mt-3"></div>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>